import {
  NetworkEventData,
  RCEvent,
  EventName,
  EventType,
} from "../../core/eventhub/eventmodels.js";
import { EventController } from "../../core/eventhub/eventcontroller.js";
import { RidecellCallback } from "../../core/models/ridecellcallback.js";
import { CarsharingNetworkRequests } from "../networkrequestsbuilder.js";

const callbackMethod = (resolve, reject) => {
  const addonsCallback = new RidecellCallback();
  addonsCallback.onSuccess = function success(result) {
    resolve(result);
  };
  addonsCallback.onFailure = (error) => {
    reject(error);
  };
  return addonsCallback;
};

export class AddonController {
  /**
   * Gets all addons over network
   *
   * @returns {Addons[]} List of all addons
   */
  getAddons(params) {
    return new Promise((resolve, reject) => {
      const queryParams = {
        ...params,
      };

      const requestData = new NetworkEventData(
        EventType.GET,
        CarsharingNetworkRequests.addons,
        queryParams //queryData
      );

      this.sendEvent(
        new RCEvent(
          EventName.NETWORK,
          requestData,
          callbackMethod(resolve, reject)
        )
      );
    });
  }

  /**
   * Get an addon by id
   *
   * @returns {AddonResponse}
   */
  getAddon({ addonID }) {
    return new Promise((resolve, reject) => {
      const requestData = new NetworkEventData(
        EventType.GET,
        CarsharingNetworkRequests.getAddon(addonID)
      );

      this.sendEvent(
        new RCEvent(
          EventName.NETWORK,
          requestData,
          callbackMethod(resolve, reject)
        )
      );
    });
  }

  /**
   * Gets all addon types over network
   *
   * @returns {AddonTypes[]} List of all addon types
   */
  getAddonTypes(params) {
    return new Promise((resolve, reject) => {
      const queryParams = {
        ...params,
      };

      const requestData = new NetworkEventData(
        EventType.GET,
        CarsharingNetworkRequests.addonTypes,
        queryParams //queryData
      );

      this.sendEvent(
        new RCEvent(
          EventName.NETWORK,
          requestData,
          callbackMethod(resolve, reject)
        )
      );
    });
  }

  /**
   * Get an addon type by id
   *
   * @returns {AddonResponse}
   */
  getAddonType({ addonTypeID }) {
    return new Promise((resolve, reject) => {
      const requestData = new NetworkEventData(
        EventType.GET,
        CarsharingNetworkRequests.getAddonType(addonTypeID)
      );

      this.sendEvent(
        new RCEvent(
          EventName.NETWORK,
          requestData,
          callbackMethod(resolve, reject)
        )
      );
    });
  }

  sendEvent(event) {
    EventController.addEvent(event);
  }

  /**
   * Get leasing addons rate
   *
   * @returns {LeasingAddonsRateResponse}
   */
  getLeasingAddonsRate(params) {
    return new Promise((resolve, reject) => {
      const queryParams = {
        ...params,
      };

      const requestData = new NetworkEventData(
        EventType.GET,
        CarsharingNetworkRequests.getLeasingAddonsRate(),
        queryParams //queryData
      );

      this.sendEvent(
        new RCEvent(
          EventName.NETWORK,
          requestData,
          callbackMethod(resolve, reject)
        )
      );
    });
  }
}
